import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import {IPresentation, IPresentationMeta} from '../../incase-domain/presentation';
import {ProtectionInfo} from '../../incase-domain/presentationProtection';
import {IPresentationShare} from '../../incase-domain/presentationShare';
import {ISlidePreview} from '../../incase-domain/proptypes/slidePreview';
import {ISlide} from '../../incase-domain/slide';
import {AppState} from '../reducer';
import {createSelectorWithShallowEqualResult, omit} from './selector.utils';

const PRESENTATION_META_OMIT_KEYS = ['slides', 'newSlides'] as const;

export const selectedPresentationSelector = (state: AppState): IPresentation => state.presentationReducer.selectedPresentation;
export const selectedPresentationSlidesSelector = (state: AppState): ISlide[] => state.presentationReducer.selectedPresentation.slides;
export const selectedPresentationWorkspaceSizeSelector = (state: AppState): IPresentation['workspaceSize'] =>
    state.presentationReducer.selectedPresentation.workspaceSize;
export const selectedPresentationBackgroundColorSelector = (state: AppState): IPresentation['backgroundColor'] =>
    state.presentationReducer.selectedPresentation.backgroundColor;
export const selectedPresentationMainBackgroundSelector = (state: AppState): IPresentation['presentationBackground'] =>
    state.presentationReducer.selectedPresentation.presentationBackground;
export const selectedPresentationMobileBackgroundSelector = (state: AppState): IPresentation['presentationMobileBackground'] =>
    state.presentationReducer.selectedPresentation.presentationMobileBackground;
export const selectedPresentationIdSelector = (state: AppState): string => state.presentationReducer.selectedPresentation._id;
export const selectedPresentationFoundSelector = (state: AppState): boolean | undefined =>
    state.presentationReducer.selectedPresentation.found;
export const selectedPresentationThemeIdSelector = (state: AppState): string | undefined =>
    state.presentationReducer.selectedPresentation.presentationThemeId;
export const selectedPresentationMetaSelector = createSelectorWithShallowEqualResult(
    selectedPresentationSelector,
    (presentation): IPresentationMeta => omit(presentation, PRESENTATION_META_OMIT_KEYS)
);
export const selectedPresentationSlidePreviewsSelector = (state: AppState): ISlidePreview[] =>
    state.presentationReducer.selectedPresentationSlidePreviews;
export const selectedPresentationSlideCountSelector = (state: AppState): number =>
    state.presentationReducer.selectedPresentation.slides.length;
export const pendingPreviewSlideIdsSelector = (state: AppState): string[] => state.presentationReducer.pendingPreviewSlideIds;
export const presentationProtectionSelector = (state: AppState): ProtectionInfo => state.presentationReducer.presentationProtection;
export const exportingPresentationsSelector = (state: AppState): string[] => state.presentationReducer.exportingPresentations;
export const presentationsValidationErrorsSelector = <T = Record<string, string[]>>(state: AppState): T =>
    state.presentationReducer.presentationValidationErrors as T;
export const emittedSharedPresentationSelector = (state: AppState): IPresentationShare =>
    state.presentationReducer.emittedSharedPresentation;
export const deletedEmittedSharedPresentationSelector = (state: AppState): string[] =>
    state.presentationReducer.deletedEmittedSharedPresentationIds;
export const selectedViewSelector = (state: AppState): DeviceType => {
    const {deviceType} = state.slideReducer.present.selectedSlide;
    if (deviceType === DeviceType.DESKTOP || deviceType === DeviceType.MOBILE) {
        return deviceType;
    }
    return state.presentationReducer.selectedView;
};
export const presentationSettingsModalSelector = (state: AppState): {open: boolean; tab?: number} =>
    state.presentationReducer.presentationSettingsModal;
